module.exports = __webpack_public_path__ + "img/bride-1.2f011107.jpg";